import imageOne from '@/assets/images/cities/mooseJaw1.jpg'
import imageTwo from '@/assets/images/cities/mooseJaw2.jpg'
import imageThree from '@/assets/images/cities/mooseJaw3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Moose Jaw',
  writeup: '',
  website: 'MooseJawNotaryPublic.com',
  url: 'https://www.moosejawnotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(306) 500-5160',
      hours: {
        monday: 'Closed',
        tuesday: '9:00AM to 12:00PM and 1:30PM to 4:30PM',
        wednesday: '9:00AM to 12:00PM and 1:30PM to 4:30PM',
        thursday: '9:00AM to 12:00PM and 1:30PM to 4:30PM',
        friday: '9:00AM to 12:00PM and 1:30PM to 4:30PM',
        saturday: 'Closed',
        sunday: 'Closed'
      },
      address: '310 Main Street Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/saskatchewan/cities/mooseJaw.js